import { IProduct } from '../../products/Product.types';

export const validateBookmark = (
  oldTransaction: IProduct,
  newTransaction: IProduct,
) => oldTransaction.product_id === newTransaction.product_id;
